// Dependencias generales
import React, { useRef } from "react";
import { useEffect, useState } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import InstalersList from '../../../components/Advisory/InstalersList'
import ReactGA from "react-ga4";
import { StandaloneSearchBox, LoadScript } from "@react-google-maps/api";

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")
var advisoryCommonJS = require("../../../js/advisoryCommon.js")
var generalCommonJS = require("../../../js/generalCommon.js")
var dashbardCommonJS = require("../../../js/dashboardCommon")
const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"
const postFVAnalysis = endpointHelias+"/Helias/V0/Advisory/postFVAnalysis"

// Advisory - Energy Billing
const AlternativeEnergySources = () => {

  useEffect(() => {    

    document.title = "HELIAS - Asesoramiento: Paneles solares"     
    document.querySelector('meta[name="description"]').setAttribute("content", "¿Quieres que te ayude a ver si te interesa instalar paneles solares?");
        
    if(initialConfigCommonJS.existeSesion()){

      var dashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))
      var numeroDiasConDatos = 0
      var timestampAhora = parseInt(Date.now() / 1000)
      var timestampDesdeRegistro = parseInt(dashboardData.SelfConsumptionAndSavingsData.SinceRegistrationlastUpdate)

      numeroDiasConDatos = (timestampAhora - timestampDesdeRegistro) / 86400

      if(numeroDiasConDatos >= 30){
        
        document.getElementById("textoNecesitoMasDatos").className = document.getElementById("textoNecesitoMasDatos").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("selectTipoSuperficieInstalacion").selectedIndex = 0

        if(!document.getElementById("divFormulario").className.includes(" hidden")){
          document.getElementById("localizadorInstaladores").className = document.getElementById("localizadorInstaladores").className.replaceAll(" hidden", "") + " hidden"
        }
            
        comprobarOpcionesSuperficie()
        cargarConfiguracionInstalacion()
      }
      else{
        document.getElementById("divFormulario").className = document.getElementById("divFormulario").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("textoNecesitoMasDatos").className = document.getElementById("textoNecesitoMasDatos").className.replaceAll(" hidden", "")      
        
        if((30 - numeroDiasConDatos) === 1 ){
          document.getElementById("textoNecesitoMasDatos").innerHTML = "Necesito monitorizar más tiempo tu instalación para poder darte una recomendación. <strong>Podré decirte algo dentro de " + parseInt(30 - numeroDiasConDatos) + " día</strong>."
        }
        else{
          document.getElementById("textoNecesitoMasDatos").innerHTML = "Necesito monitorizar más tiempo tu instalación para poder darte una recomendación. <strong>Podré decirte algo dentro de " + parseInt(30 - numeroDiasConDatos) + " días</strong>."
        }   
      }
    }
    else{ // Estoy consultando desde el área pública
      // Meter campos adicionales en el formulario y modificar lambda de asesoramiento para que los tome como parámetros.
      console.log("Simulación desde área pública")
    }

    console.log("Abro asesoramiento para paneles solares.")

  });

  const [objListadoInstaladores, setObjListadoInstaladores] = useState([])  

  var instalacionConectadaARed = false
  var latitudInstalacion = 0
  var longitudInstalacion = 0
  
  const inputRef = useRef();

  const handlePlaceChanged = () => { 
    const [ place ] = inputRef.current.getPlaces();

    if(place) { 
      try{
        for(var x=0; x < place.address_components.length; x++){
          if(place.address_components[x].types[0] === "postal_code"){
            document.getElementById("latitudInstalacion").value = place.geometry.location.lat()
            document.getElementById("longitudInstalacion").value = place.geometry.location.lng()
          }
        }          
        
      }
      catch (error){}
    } 
  }

  function cargarConfiguracionInstalacion(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var installationId = localStorage.getItem("installationId")    
  
    document.getElementById("loaderDetalleAdvisory").className="loader overlay"

    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": installationId,
      "GeneralInfo": "",
      "Battery":"",
      "Generator": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
  
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            //Si recibo datos ya configurados lo cargo  
  
            document.getElementById("loaderDetalleAdvisory").className="loader hidden"

            var configuracionInstalacion = jsonRespuesta.body

            if(configuracionInstalacion.GeneralInfo.EnergyGridConnected === "true"){              
              instalacionConectadaARed = true              
            }
            else{              
              instalacionConectadaARed = false              
            }

            latitudInstalacion = configuracionInstalacion.GeneralInfo.InstallationLocationLatitude
            longitudInstalacion = configuracionInstalacion.GeneralInfo.InstallationLocationLongitude

            //Si no hay datos configurados entonces no hago nada  
            console.log("Configuración existente en BBDD cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);      
  }

  function calcularM2(){

    var ancho = document.getElementById("anchoSuperficieInstalacion").value.replaceAll(",",".")
    var largo = document.getElementById("largoSuperficieInstalacion").value.replaceAll(",",".")

    if ( (ancho !== "") && (largo !== "") ){
      document.getElementById("metrosCuadradosDisponibles").innerHTML = (parseFloat(ancho)*parseFloat(largo)).toFixed(2) + " m2"
    }
    else{
      document.getElementById("metrosCuadradosDisponibles").innerHTML = "0 m2"      
    }

  }

  function validacionCamposCorrecta(){
    
    var numeroErroresValidacion = 0

    if(!initialConfigCommonJS.existeSesion()){

      if(document.getElementById("latitudInstalacion").value === ""){
        document.getElementById("direccion").className = "error"
        numeroErroresValidacion++    
      }

      if(document.getElementById("longitudInstalacion").value === ""){
        document.getElementById("direccion").className = "error"
        numeroErroresValidacion++    
      }

      if(document.getElementById("consumoTotal").value === ""){
        document.getElementById("consumoTotal").className = "error"
        numeroErroresValidacion++    
      }

      if(document.getElementById("gastoFactura").value === ""){
        document.getElementById("gastoFactura").className = "error"
        numeroErroresValidacion++    
      }

      if(document.getElementById("consumoPunta").value === ""){
        document.getElementById("consumoPunta").className = "error"
        numeroErroresValidacion++    
      }

      if(document.getElementById("consumoLlano").value === ""){
        document.getElementById("consumoLlano").className = "error"
        numeroErroresValidacion++    
      }

      if(document.getElementById("consumoValle").value === ""){
        document.getElementById("consumoValle").className = "error"
        numeroErroresValidacion++    
      }

    }

    if(document.getElementById("anchoSuperficieInstalacion").value === ""){
      document.getElementById("anchoSuperficieInstalacion").className = "error"
      numeroErroresValidacion++    
    }

    if(document.getElementById("largoSuperficieInstalacion").value === ""){
      document.getElementById("largoSuperficieInstalacion").className = "error"
      numeroErroresValidacion++    
    }

    if(numeroErroresValidacion > 0){    
      document.getElementById("loaderDetalleAdvisory").className="loader hidden"      
      initialConfigCommonJS.mostrarMensajeInformativo("Debes rellenar todos los campos marcados en rojo antes de continuar.","negative")
      return false
    }
    else{
      document.getElementById("anchoSuperficieInstalacion").className = ""
      document.getElementById("largoSuperficieInstalacion").className = ""
      document.getElementById("loaderDetalleAdvisory").className="loader hidden"      
      return true
    }
    
  }

  function calcularTablaResultados(){

    if(validacionCamposCorrecta()){

      document.getElementById("divContenedorDetalleAdvisory").scrollTop = 0

      try{
        document.getElementById("volverAsesoramientoPublico").className = document.getElementById("volverAsesoramientoPublico").className.replaceAll(" hidden", "") + " hidden"
      }catch(error){}

      document.getElementById("divTablaResultados").className = document.getElementById("divTablaResultados").className.replaceAll(" hidden", "")      

      var formatter = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      });
      
      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")          

      document.getElementById("loaderDetalleAdvisory").className="loader overlay"
      
      var idInstalacion = ""

      if(initialConfigCommonJS.existeSesion()){
        idInstalacion = localStorage.getItem("installationId")
        instalacionConectadaARed = instalacionConectadaARed.toString()        
      }
      else{
        idInstalacion = ""
        instalacionConectadaARed = document.getElementById("selectFVConectadaRed").value
        latitudInstalacion = document.getElementById("latitudInstalacion").value
        longitudInstalacion = document.getElementById("longitudInstalacion").value        
      }


      var jsonAnalisis = {}
      
      if(initialConfigCommonJS.existeSesion()){
        jsonAnalisis = {
          "idInstalacion": idInstalacion,        
          "instalacionConectadaARed": instalacionConectadaARed,
          "latitudInstalacion": latitudInstalacion,
          "longitudInstalacion": longitudInstalacion,        
          "m2disponibles": document.getElementById("metrosCuadradosDisponibles").innerHTML.replaceAll(" m2", ""),
          "orientacionTejado": document.getElementById("selectOrientacionTejado").value,
          "tipoSuperficieInstalacion": document.getElementById("selectTipoSuperficieInstalacion").value        
        }
      }
      else{
        jsonAnalisis = {
          "idInstalacion": idInstalacion,        
          "instalacionConectadaARed": instalacionConectadaARed,
          "latitudInstalacion": latitudInstalacion,
          "longitudInstalacion": longitudInstalacion,        
          "m2disponibles": document.getElementById("metrosCuadradosDisponibles").innerHTML.replaceAll(" m2", ""),
          "orientacionTejado": document.getElementById("selectOrientacionTejado").value,
          "tipoSuperficieInstalacion": document.getElementById("selectTipoSuperficieInstalacion").value,
          "consumoTotal": document.getElementById("consumoTotal").value.replaceAll(",","."),
          "gastoFactura": document.getElementById("gastoFactura").value.replaceAll(",","."),
          "consumoPunta": document.getElementById("consumoPunta").value.replaceAll(",","."),
          "consumoLlano": document.getElementById("consumoLlano").value.replaceAll(",","."),
          "consumoValle": document.getElementById("consumoValle").value.replaceAll(",",".")
        }
      }

      var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postFVAnalysis, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");    
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonAnalisis)
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)              

          document.getElementById("loaderDetalleAdvisory").className="loader hidden"

          document.getElementById("divFormulario").className += " hidden"          
          document.getElementById("divTablaResultados").className = document.getElementById("divTablaResultados").className.replace(" hidden", "")

          document.getElementById("numeroPlacas").innerHTML = jsonRespuesta.body.solarPanelsNeeded
          document.getElementById("numeroInversores").innerHTML = jsonRespuesta.body.invertersNeeded
          document.getElementById("potenciaMaximaTeorica").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.maximunTheoricalPower).toFixed(1)) + " kW"
          document.getElementById("consumoMedioAnualInstalacion").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.installationAverageConsumptionAYear).toFixed(0))+ " kW"
          document.getElementById("consumoMedioMensualInstalacion").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.installationAverageConsumptionAMonth).toFixed(0))+ " kW"
          document.getElementById("consumoMedioDiarioInstalacion").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.installationAverageConsumptionADay).toFixed(0))+ " kW"
          document.getElementById("mesMax").innerHTML = dashbardCommonJS.obtenerNombreMes(jsonRespuesta.body.maxPowerMonth)
          document.getElementById("mesMin").innerHTML = "&nbsp;&nbsp;" + dashbardCommonJS.obtenerNombreMes(jsonRespuesta.body.minPowerMonth)
          document.getElementById("potenciaMax").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.maxPowerValue).toFixed(1)) + " kW"
          document.getElementById("potenciaMin").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.minPowerValue).toFixed(1)) + " kW"
          document.getElementById("generacionMaximaMensualMax").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.maxEnergyValue).toFixed(0)) + " kW"
          document.getElementById("generacionMediaDiariaMax").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.maxPowerDailyAverage).toFixed(0)) + " kW"
          document.getElementById("generacionMaximaMensualMin").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.minEnergyValue).toFixed(0)) + " kW"
          document.getElementById("generacionMediaDiariaMin").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.minPowerDailyAverage).toFixed(0)) + " kW"          
          document.getElementById("eficiencia").innerHTML = new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.fvInstallationEfficiency)+ " %"
          document.getElementById("amortizacionAnual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.fvInstallationAmortizationEurosYear).toFixed(1)) + " € / Año"
          document.getElementById("amortizacionTemporal").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.fvInstallationTotalAmortizationYears).toFixed(1)) +" Años"
          document.getElementById("conclusion").innerHTML = jsonRespuesta.body.fvInstallationProfitabilityConclusion
          
          //new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyRevenue.SoldEnergy).toFixed(2)) + " €"

          document.getElementById("divResumenResultados").className = document.getElementById("divResumenResultados").className.replaceAll(" success", "").replaceAll(" error", "").replaceAll(" warning", "")

          if(jsonRespuesta.body.fvInstallationProfitabilityConclusion === "OK"){                        
            document.getElementById("divResumenResultados").className += " success"
            document.getElementById("iconoResultado").innerHTML = "thumb_up"
            document.getElementById("conclusion").innerHTML = "Sí, te interesa instalar paneles solares"            
          }
          else if(jsonRespuesta.body.fvInstallationProfitabilityConclusion === "KO"){
            document.getElementById("divResumenResultados").className += " error"
            document.getElementById("iconoResultado").innerHTML = "thumb_down"
            document.getElementById("conclusion").innerHTML = "No te interesa instalar paneles solares"            
          }
          else if(jsonRespuesta.body.fvInstallationProfitabilityConclusion === "RISK"){
            document.getElementById("divResumenResultados").className += " warning"
            document.getElementById("iconoResultado").innerHTML = "thumbs_up_down"
            document.getElementById("conclusion").innerHTML = "Deberías instalar paneles solares, aunque tardarás en amortizarlos."            
          }

          //Cálculo de presupuesto          
          var presupuestoFinal = jsonRespuesta.body.fvInstallationBudget
          var valorSubvencion = parseFloat(parseFloat(presupuestoFinal)*0.4).toFixed(2)

          var tipoInstalacion = "PISO"

          try{
            tipoInstalacion = localStorage.getItem("installationName").split("*")[0]
          }catch(error){}
          
          if(tipoInstalacion !== "COMUNIDAD"){
            if(valorSubvencion > parseFloat(3000) ){
              valorSubvencion = 3000
            }
          }
          else{
            if(valorSubvencion > parseFloat(15000) ){
              valorSubvencion = 15000
            }
          }

          if(jsonRespuesta.body.appliesFVSubvention === "true"){            
            presupuestoFinal = presupuestoFinal - valorSubvencion
            document.getElementById("presupuesto").innerHTML = formatter.format(Number(presupuestoFinal))            
            document.getElementById("presupuesto").innerHTML += '<p class="size-s">'+formatter.format(Number(jsonRespuesta.body.fvInstallationBudget)) + " - "+formatter.format(Number(valorSubvencion))+" (Sub) </p>"
          }
          else{
            document.getElementById("presupuesto").innerHTML = formatter.format(Number(presupuestoFinal))
          }

          document.getElementById("resumenInicial").innerHTML = "Con una inversión de <strong>"+new Intl.NumberFormat('en-DE').format(presupuestoFinal)+" €</strong>"

          //Resumen final
          if(jsonRespuesta.body.appliesFVSubvention === "true"){ document.getElementById("resumenInicial").innerHTML += " (incluye subvención) " } 
          else{ document.getElementById("resumenInicial").innerHTML += " (no te aplica subvención) " }

          document.getElementById("resumenInicial").innerHTML +=
          " conseguirías un <strong>"+new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.fvInstallationEfficiency)+" %</strong> de aprovechamiento energético, "+
          "tendrías un ahorro de <strong>"+new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.fvInstallationAmortizationEurosYear)+" €</strong> al año "

          if(jsonRespuesta.body.fvInstallationProfitabilityConclusion === "KO"){
            document.getElementById("resumenInicial").innerHTML += " lo cual es muy poco y por tanto tardarías demasiado en amortizarlo (<strong>"+ new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.fvInstallationTotalAmortizationYears) + " años</strong>)."
          }
          else{
            document.getElementById("resumenInicial").innerHTML += " y lo amortizarías en <strong>"+ new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.fvInstallationTotalAmortizationYears) + " años</strong>."
          }

          

          //Actualizo los trámites
          document.getElementById("listadoTramites").innerHTML = ""

          if(jsonRespuesta.body.appliesFVSubvention === "true"){
            document.getElementById("listadoTramites").innerHTML += '<li class="success">Te correspondería una <strong>subvención de '+formatter.format(Number(valorSubvencion))+', por tanto habría que solicitarla</strong>. Esto lo gestiona el instalador, pero si no te lo puede hacer una gestoría.</li>'
            document.getElementById("listadoTramites").innerHTML += '<ul class="default-list"><li>¡Ojo! porque las subvenciones son limitadas, podrían acabarse o rechazártela por algún motivo.</li><li>Te debes comprometer a tener un aprovechamiento energético del 80% (que autoconsumas el 80% de la energía que generas), si no podrían retirártela.</li></ul>'
          }
          
          document.getElementById("listadoTramites").innerHTML += '<li class="success"><strong>Permiso al ayuntamiento</strong> para la instalación de los paneles, lo gestiona el instalador.</li>'

          var permisoComunidad = '<li class="success"><strong>Si vives en una comunidad de vecinos debes solicitarles permiso</strong> para la instalación de los paneles. Con que el 60% estén de acuerdo sería suficiente.</li>'
          var certificadoEstabilidad = '<li class="success"><strong>Certificado de estabilidad estructural</strong>. Te lo gestiona el instalador, pero si no se lo puedes pedir a cualquier arquitecto.</li><p></p>'          
          document.getElementById("listadoTramites").innerHTML += permisoComunidad+certificadoEstabilidad
          
          document.getElementById("loaderDetalleAdvisory").className="loader hidden"
          document.getElementById("divContenedorDetalleAdvisory").scrollTop = 0
          
          generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - Sim. FV', jsonRespuesta.body.fvInstallationProfitabilityConclusion, "")

          if(jsonRespuesta.body.fvInstallationProfitabilityConclusion === "KO"){
            document.getElementById("divDetalleResultados").className = document.getElementById("divDetalleResultados").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("ulBotonBuscarInstalador").className = document.getElementById("ulBotonBuscarInstalador").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("divAlternativaSinSuperficiePostAnalisis").className = document.getElementById("divAlternativaSinSuperficiePostAnalisis").className.replaceAll(" hidden", "")
          }
          else{
            document.getElementById("divDetalleResultados").className = document.getElementById("divDetalleResultados").className.replaceAll(" hidden", "")
            document.getElementById("ulBotonBuscarInstalador").className = document.getElementById("ulBotonBuscarInstalador").className.replaceAll(" hidden", "")
            document.getElementById("divAlternativaSinSuperficiePostAnalisis").className = document.getElementById("divAlternativaSinSuperficiePostAnalisis").className.replaceAll(" hidden", "") + " hidden"
          }

          console.log("Presupuesto FV realizado correctamente")
        }
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);      

    }

  }

  function comprobarOpcionesSuperficie(){

    if(document.getElementById("selectTipoSuperficieInstalacion").value === "none"){
      document.getElementById("formulario").className += " hidden"
      document.getElementById("divAlternativaSinSuperficie").className = document.getElementById("divAlternativaSinSuperficie").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("formulario").className = document.getElementById("formulario").className.replaceAll(" hidden", "")
      document.getElementById("divAlternativaSinSuperficie").className += " hidden"
    }

  }

  function actualizarColumna(){
    if(document.getElementById("max").checked === true){ document.getElementById("tablaValoresEstimacion").className = "min" }
    else{ document.getElementById("tablaValoresEstimacion").className = "max" }
  }

  function volver(){
    
    try{
      document.getElementById("volverAsesoramientoPublico").className = document.getElementById("volverAsesoramientoPublico").className.replaceAll(" hidden", "")
    }catch(error){}

    document.getElementById("divFormulario").className = document.getElementById("divFormulario").className.replaceAll(" hidden", "")
    document.getElementById("divTablaResultados").className += " hidden"     
  }

  function volverAResultados(){
    document.getElementById("localizadorInstaladores").className += " hidden"
    document.getElementById("divTablaResultados").className = document.getElementById("divTablaResultados").className.replaceAll(" hidden", "")
  }

  return (      
    <main className="no-background">

      <section id="detalleAdvisoryFuentesAlternativasEnergia" className="step">

        <p id="textoNecesitoMasDatos"></p>

        <div id="divFormulario" className="content-wrapper">          

          <p>Hoy en día hay muchos tipos de energías alternativas para uso privado, pero en términos generales la única renovable a un precio asequible, con buen rendimiento, de fácil instalación y 100% verde es la energía solar. Rellena los siguientes datos y te diré si te interesa.</p>

          { !initialConfigCommonJS.existeSesion() ?
              <p>Y tranquil@ que los datos de este formulario <strong>ni se guardan ni se comparten</strong>...</p>
            :
              <></>
          }

          <fieldset>

            { !initialConfigCommonJS.existeSesion() ?
              <>
                <fieldset>                  
                  <label className="has-tooltip" htmlFor="labelDireccion">
                    <span className="label tooltip-label">Dirección</span>              
                  </label>

                  <div className="text">
                    <LoadScript googleMapsApiKey={"AIzaSyAKzBBmfUcgXRb4q_uUmLtZDUS9aedgsX4"} libraries={["places"]}>
                      <StandaloneSearchBox
                          onLoad={ref => inputRef.current = ref}
                          placeholder=" "                        
                          onPlacesChanged={handlePlaceChanged}                        
                      >
                        <input
                            id="direccion"
                            type="text"
                            placeholder=""
                            onKeyDown={e => {                         
                              if (e.keyCode === 13) {e.preventDefault(); }}                            
                            }                        
                        />
                      </StandaloneSearchBox>
                    </LoadScript>
                  </div>

                  <input type="text" inputMode="decimal" id="latitudInstalacion" className=" hidden"/>
                  <input type="text" inputMode="decimal" id="longitudInstalacion" className=" hidden"/>

                </fieldset>
              
                <fieldset className="dropdown hidden">
                  <label htmlFor="labelFVConectadaRed">¿Está la instalación conectada a la red general?</label>            
                  <div className="icon-wrapper">
                    <select id="selectFVConectadaRed">
                      <option value="true">Sí</option>
                      <option value="false">No</option>                                  
                    </select>
                  </div>
                </fieldset>
              </>
            :
              <></>
            }


            <fieldset className="dropdown">
              <label htmlFor="labelTipoSuperficieInstalacion">¿En qué tipo de superficie vas a instalar los paneles?</label>            
              <div className="icon-wrapper">
                <select id="selectTipoSuperficieInstalacion" onChange={() => comprobarOpcionesSuperficie()}>
                  <option value="building">Tejado de un edificio</option>
                  <option value="free">En una estructura distinta a un tejado</option>                
                  <option value="none">No tengo superficie en la que instalar los paneles</option>                
                </select>
              </div>
            </fieldset>

            <div id="divAlternativaSinSuperficie" className="vertical gap-04 hidden">

              <p>No te preocupes, aunque no tengas superficie para instalar paneles sigues teniendo opciones de beneficiarte del autoconsumo solar. Te presento a <strong>Comunidad solar</strong>, se encargan de instalar paneles solares en zonas remotas y hacen llegar esa electricidad a tu casa.</p>

              <div className="video-wrapper">
                <iframe 
                  width="100%" 
                  height="auto" 
                  src="https://www.youtube.com/embed/sdthY1QK4Qg" 
                  title="Comunidad solar" 
                  frameBorder="0" 
                  allow="accelerometer;clipboard-write;encrypted-media;gyroscope;picture-in-picture" 
                  allowFullScreen>                
                </iframe>
              </div>

              <fieldset>                            
                <a href="https://comunidadsolar.es/autoconsumo-remoto/" className="button primary full-width" target="_blank" rel="noopener noreferrer">Me interesa, quiero más información</a>                
              </fieldset>              

            </div>

            <div id="formulario">

              <fieldset>              

              <fieldset className="two-columns">
                
                <fieldset className="dropdown">
                  <label htmlFor="labelOrientacionTejado">¿Qué orientación tiene la mayor parte de la superficie?</label>              
                  <div className="icon-wrapper">
                    <select id="selectOrientacionTejado">
                      <option value="0">Sur</option>
                      <option value="-45">Sureste</option>
                      <option value="-90">Este</option>
                      <option value="45">Noreste</option>
                      <option value="90">Norte</option>
                      <option value="-45">Noroeste</option>
                      <option value="90">Oeste</option>
                      <option value="45">Suroeste</option>                
                    </select>
                  </div>
                </fieldset>

              </fieldset>

              <fieldset>

                <fieldset className="two-columns">
                    
                    <fieldset>
                      <label htmlFor="anchoSuperficieInstalacion">Ancho superficie</label>            
                      <fieldset className="icon-wrapper data" data-label="M">            
                        <input type="text" inputMode="decimal" id="anchoSuperficieInstalacion" onKeyUp={() => calcularM2()}/>
                      </fieldset>
                    </fieldset>
                    
                    <fieldset>
                      <label htmlFor="largoSuperficieInstalacion">Largo superficie</label>            
                      <fieldset className="icon-wrapper data" data-label="M">            
                        <input type="text" inputMode="decimal" id="largoSuperficieInstalacion" onKeyUp={() => calcularM2()}/>
                      </fieldset>
                    </fieldset>

                    <fieldset className="result vertical">
                      <label htmlFor="labelMetrosCuadradosDisponibles">m² totales</label>
                      <h1 className="value" id="metrosCuadradosDisponibles" data-label="m2">0 m²</h1>
                    </fieldset>
                    
                  </fieldset>

                </fieldset>

                { !initialConfigCommonJS.existeSesion() ?
                  <>

                    <fieldset>

                      <div className="message info left" style={{ marginTop: "20px"}}>
                        <h1 className="title"><span className="material-icon">info</span>Datos de tu última factura</h1>
                        <p className="size-s">Necesitas una factura para rellenar la siguiente información, te recomendamos usar cualquiera que NO sea de los siguientes meses: diciembre, enero, julio o agosto.</p>                              
                      </div>

                      <fieldset className="two-columns">
                        
                        <fieldset>
                          <label htmlFor="consumoTotal">Consumo total</label>            
                          <fieldset className="icon-wrapper data" data-label="kWh">            
                            <input type="text" inputMode="decimal" id="consumoTotal"/>
                          </fieldset>
                        </fieldset>

                        <fieldset>
                          <label htmlFor="gastoFactura">Total factura</label>            
                          <fieldset className="icon-wrapper data" data-label="€">            
                            <input type="text" inputMode="decimal" id="gastoFactura"/>
                          </fieldset>
                        </fieldset>

                      </fieldset>

                    </fieldset>

                    <fieldset className="two-columns">

                      <fieldset>
                        <label htmlFor="consumoPunta">Consumo punta</label>            
                        <fieldset className="icon-wrapper data" data-label="kWh">            
                          <input type="text" inputMode="decimal" id="consumoPunta"/>
                        </fieldset>
                      </fieldset>

                      <fieldset>
                        <label htmlFor="consumoLlano">Consumo llano</label>            
                        <fieldset className="icon-wrapper data" data-label="kWh">            
                          <input type="text" inputMode="decimal" id="consumoLlano"/>
                        </fieldset>
                      </fieldset>

                      <fieldset>
                        <label htmlFor="consumoValle">Consumo valle</label>            
                        <fieldset className="icon-wrapper data" data-label="kWh">            
                          <input type="text" inputMode="decimal" id="consumoValle"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>
                  </>
                :
                  <></>
                }

                { !initialConfigCommonJS.existeSesion() ?
                    <p>Esta simulación es para tarifas 2.0. Si estuvieras registrado en Helias podrías simular tarifas 3.0, además los datos se tomarían automáticamente de tus mediciones, obteniendo unos resultados más precisos.</p>
                  :
                    <></>
                }

                <fieldset className="actions">            
                  <button id="simuladorFV" className="button primary full-width" onClick={() => calcularTablaResultados()}>Dime si me interesa instalar paneles</button>         
                </fieldset>
              
              </fieldset>

            </div>        

          </fieldset>

        </div>

        <div id="divTablaResultados" className="content-wrapper hidden" >

          <button className="link back" onClick={() => volver()}><span className="material-icon">arrow_back</span>Volver</button>

          <div id="divResumenResultados" className="message medium left">
            <div className="horizontal">
              <span id="iconoResultado" className="material-icon"></span>
              <h1 className="title" id="conclusion"> </h1>
            </div>
            <p id="resumenInicial"></p>
          </div>

          <div id="divAlternativaSinSuperficiePostAnalisis" className="vertical gap-04 hidden">

          <p>A día de hoy mi consejo para ahorrar es que te centres en <strong>reducir tu consumo, tener buena tarifa eléctrica y bajar tu potencia contratada a lo que realmente necesites</strong>. Para todo esto yo te ayudaré revisando constantemente tu instalación y te avisaré cuando vea que puedes mejorar alguno de estos puntos.</p>

          <p>Aun así existe otra opción de autoconsumo que puede que te interese. Se trata de los <strong>paneles remotos</strong>. Aquí te dejo un video de la empresa <strong>Comunidad solar</strong> donde se explica todo en detalle.</p>

          <div className="video-wrapper">
            <iframe 
              width="100%" 
              height="auto" 
              src="https://www.youtube.com/embed/sdthY1QK4Qg" 
              title="Comunidad solar" 
              frameBorder="0" 
              allow="accelerometer;clipboard-write;encrypted-media;gyroscope;picture-in-picture" 
              allowFullScreen>                
            </iframe>
          </div>

          <fieldset>                        
            <a href="https://comunidadsolar.es/autoconsumo-remoto/" className="button primary full-width" target="_blank" rel="noopener noreferrer">Me interesa, quiero más información</a>                
          </fieldset>              

          </div>

          <div id="divDetalleResultados" className="accordion-wrapper">

            <details className="accordion">
              <summary className="title">                  
                <span className="size-l">¿Qué trámites tengo que hacer?</span>
                </summary>
              <ul id="listadoTramites" className="default-list"/>                             
            </details>

            <details className="accordion green">
              <summary className="title">                  
                <span className="size-l">Componentes de la instalación</span>
              </summary>
              <ul className="accordion-content columns col-sm-2" >
                <li className="horizontal gap-03 center">
                  <figure className="avatar size-l"><span className="material-icon">grid_view</span></figure>
                  <dl className="vertical fill">
                    <dt className="size-m">Número de placas</dt>
                    <dd id="numeroPlacas" className="size-l"></dd>
                  </dl>
                </li>
                <li className="horizontal gap-03 center">
                  <figure className="avatar size-l"><span className="material-icon">monitor_heart</span></figure>
                  <dl className="vertical fill">
                    <dt className="size-m">Inversor/es</dt>
                    <dd id="numeroInversores" className="size-l"></dd>
                  </dl>
                </li>

              </ul>
            </details>

            <details className="accordion">
              
              <summary className="title">                
                <span className="size-l">Datos teóricos</span>                
              </summary>

              <div className="accordion-content">
                <table>
                  <tbody>
                    <tr className="table-row">
                      <td className="table-cell label">Potencia máxima</td>
                      <td className="table-cell value" id="potenciaMaximaTeorica"></td>
                    </tr>

                    <tr className="table-row">
                      <td className="table-cell label">Consumo medio anual</td>
                      <td className="table-cell value" id="consumoMedioAnualInstalacion"></td>                    
                    </tr>

                    <tr className="table-row">
                      <td className="table-cell label">Consumo medio mensual</td>
                      <td className="table-cell value" id="consumoMedioMensualInstalacion"></td>                    
                    </tr>
                    <tr className="table-row">
                      <td className="table-cell label">Consumo medio diario</td>
                      <td className="table-cell value" id="consumoMedioDiarioInstalacion"></td>                                        
                    </tr>                  
                  </tbody>
                </table>
              </div>

            </details>

            <details className="accordion comparison">
              
              <summary className="title">                
                <span className="size-l">Datos análisis</span>   
              </summary>              

              <fieldset className="radio multiple center" id="minMax">
                <div className="tabs size-s">
                  <input type="radio" id="max" name="minMax" defaultChecked onChange={() => actualizarColumna()}/>
                  <label htmlFor="max"><span className="label uppercase">Mínimo</span></label>
                  <input type="radio" id="min" name="minMax" onChange={() => actualizarColumna()}/>
                  <label htmlFor="min"><span className="label uppercase">Máximo</span></label>
                </div>
              </fieldset>

              <table id="tablaValoresEstimacion" className="min">
                <thead>
                  <tr className="table-row">
                    <th className="table-cell label"></th>
                    <th className="table-cell max">Máximo</th>
                    <th className="table-cell min">Mínimo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="table-row">
                    <td className="table-cell label">Mes</td>
                    <td className="table-cell max" id="mesMax"></td>
                    <td className="table-cell min" id="mesMin"></td>
                  </tr>

                  <tr className="table-row">
                    <td className="table-cell label">Potencia real estimada</td>
                    <td className="table-cell max" id="potenciaMax"></td>
                    <td className="table-cell min" id="potenciaMin"></td>
                  </tr>
                  <tr className="table-row">
                    <td className="table-cell label">Generación máxima mensual</td>
                    <td className="table-cell max">
                      <div className="vertical">
                        <span id="generacionMaximaMensualMax"></span>                        
                      </div>
                    </td>
                    <td className="table-cell min">
                      <div className="vertical">
                        <span id="generacionMaximaMensualMin"></span>                        
                      </div>
                    </td>
                  </tr>
                  <tr className="table-row">
                    <td className="table-cell label">Generación media diaria</td>
                    <td className="table-cell max">
                      <div className="vertical">
                        <span id="generacionMediaDiariaMax"></span>                        
                      </div>
                    </td>
                    <td className="table-cell min">
                      <div className="vertical">
                        <span id="generacionMediaDiariaMin"></span>                        
                      </div>
                    </td>
                  </tr>
                  <tr className="table-row">
                    <td className="table-cell label">
                      <div className="vertical">
                        <span>Presupuesto final</span>
                        <span className="size-xs"></span>
                      </div>
                    </td>
                    <td className="table-cell value" id="presupuesto" colSpan={"2"}></td>
                  </tr>
                  <tr className="table-row">
                    <td className="table-cell label">Aprovechamiento energético</td>
                    <td className="table-cell value" colSpan={"2"}>
                      <div className="vertical">
                        <span id="eficiencia"></span>
                      </div>
                    </td>
                  </tr>
                  <tr className="table-row">
                    <td className="table-cell label">Ahorro</td>
                    <td className="table-cell value fill" colSpan={"2"}>
                      <div className="vertical">
                        <span id="amortizacionAnual"></span>                        
                      </div>
                    </td>
                  </tr>
                  <tr className="table-row">
                    <td className="table-cell label">Amortización</td>
                    <td className="table-cell value fill" colSpan={"2"}>
                      <div className="vertical">
                        <span id="amortizacionTemporal"></span>                        
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </details>

          </div>
        
          <ul id="ulBotonBuscarInstalador" className="actions">         
            <button id="botonContactoInstalador" className="button primary full-width" onClick={() => advisoryCommonJS.mostrarInstaladoresCercanos("instalacion paneles solares",setObjListadoInstaladores)}>Ponme en contacto con un instalador ahora mismo</button>       
          </ul>

        </div>

        <div id="localizadorInstaladores" className=" hidden">

          <button className="link back" onClick={() => volverAResultados()}><span className="material-icon">arrow_back</span>Volver</button>

          <ul className="providers-list vertical gap-06">

          <InstalersList objListadoInstaladores={objListadoInstaladores}/>

          </ul>

        </div>

      </section>

      

    </main>
  )
}

export default AlternativeEnergySources